import React, { useState, useEffect } from 'react'; 
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  ThemeProvider,
  createTheme,
  AppBar
} from '@mui/material';
import { salaryGroupSettingsApi } from '../../../Data/axios';

const SalaryGroups = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [updateDialog, setUpdateDialog] = useState(false);
  const [name, setName] = useState('');
  const [assignedSalaryComponents, setAssignedSalaryComponents] = useState('');
  const [salaryGroups, setSalaryGroups] = useState([]);
  const [currentGroup, setCurrentGroup] = useState(null);

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
    });

  const fetchSalaryGroups = async () => {
    try {
      const response = await salaryGroupSettingsApi.getAll();
      setSalaryGroups(response.data);
      console.log(response)
    } catch (error) {
      console.error("Error fetching salary groups:", error);
    }
  };

  async function SaveDate() {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("assignedSalaryComponents", assignedSalaryComponents);

      await salaryGroupSettingsApi.add(formData);
      fetchSalaryGroups();
      setOpenDialog(false);
      setName('');
      setAssignedSalaryComponents('');
    } catch (error) {
      console.error("Error adding salary group:", error);
    }
  }

  const updateSalaryGroup = async () => {
    try {
      if (currentGroup) {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("assignedSalaryComponents", assignedSalaryComponents);

        await salaryGroupSettingsApi.update(currentGroup.id, formData);
        fetchSalaryGroups();
        setUpdateDialog(false);
        setName('');
        setAssignedSalaryComponents('');
        setCurrentGroup(null);
      }
    } catch (error) {
      console.error("Error updating salary group:", error);
    }
  };

  const deleteSalaryGroup = async (id) => {
    try {
      await salaryGroupSettingsApi.delete(id);
      fetchSalaryGroups();
    } catch (error) {
      console.error("Error deleting salary group:", error);
    }
  };

  const handleEdit = (group) => {
    setCurrentGroup(group);
    setName(group.name);
    setAssignedSalaryComponents(group.assignedSalaryComponents);
    setUpdateDialog(true);
  };

  useEffect(() => {
    fetchSalaryGroups();
  }, []);

  return (
    <ThemeProvider theme={getTheme()}>
      <div style={{ padding: '20px' }}>

        <Button variant="contained" color="primary" onClick={() => setOpenDialog(true)} sx={{"&:hover": { backgroundColor: "orange" },}}>
          Add Salary Group
        </Button>

        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead style={options.tableHead.style}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Salary Components</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody style={options.tableBody.style}>
              {salaryGroups.length > 0 ? (
                salaryGroups.map((group) => (
                  <TableRow key={group.id}>
                    <TableCell>{group.name}</TableCell>
                    <TableCell>{group.assignedSalaryComponents}</TableCell>
                    <TableCell>
                      <Button color="primary" onClick={() => handleEdit(group)} variant="outlined" sx={{marginRight:"5px"}}>
                        Edit
                      </Button>
                      <Button color="secondary" onClick={() => deleteSalaryGroup(group.id)} variant="outlined">
                        Delete
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3} align="center">
                    - No salary group added. -
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth maxWidth="sm">
        <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
          <DialogTitle sx={{color:"white"}}>Add Salary Group</DialogTitle>
        </AppBar>
          <DialogContent>
            <TextField
              fullWidth
              label="Name"
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              select
              fullWidth
              label="Assigned Salary Components"
              margin="normal"
              value={assignedSalaryComponents}
              onChange={(e) => setAssignedSalaryComponents(e.target.value)}
            >
              <MenuItem value="Component 1">Component 1</MenuItem>
              <MenuItem value="Component 2">Component 2</MenuItem>
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDialog(false)} color="secondary" sx={{color:"grey"}}>
              Cancel
            </Button>
            <Button onClick={SaveDate} color="primary" variant="contained" sx={{"&:hover": { backgroundColor: "orange" },}}>
              Add
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={updateDialog} onClose={() => setUpdateDialog(false)} fullWidth maxWidth="sm">
          <DialogTitle>Update Salary Group</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              label="Name"
              margin="normal"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <TextField
              select
              fullWidth
              label="Assigned Salary Components"
              margin="normal"
              value={assignedSalaryComponents}
              onChange={(e) => setAssignedSalaryComponents(e.target.value)}
            >
              <MenuItem value="Component 1">Component 1</MenuItem>
              <MenuItem value="Component 2">Component 2</MenuItem>
            </TextField>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdateDialog(false)} color="secondary">
              Cancel
            </Button>
            <Button onClick={updateSalaryGroup} color="primary" variant="contained">
              Update
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </ThemeProvider>
  );
};

export default SalaryGroups;
